import React from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";

import { cn } from "../../lib/utils";
import { Extra, WithId, formatCurrency } from "../../lib/pricing";
import { Tone, tones } from "./tones";

interface Props {
  extras: WithId<Extra>[];
  selected: string[];
  onToggle: (extraId: string) => void;
  tone?: Tone;
}

export default function ExtrasPicker({ extras, selected, onToggle, tone = "light" }: Props) {
  const { t } = useTranslation();
  const c = tones[tone];
  const active = extras.filter((e) => e.active);
  if (active.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {active.map((extra) => {
        const isOn = selected.includes(extra.id);
        return (
          <button
            key={extra.id}
            type="button"
            role="checkbox"
            aria-checked={isOn}
            onClick={() => onToggle(extra.id)}
            className={cn(
              "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition",
              isOn ? c.chipActive : c.chip
            )}
          >
            <span
              className={cn(
                "flex h-4 w-4 items-center justify-center rounded-full border",
                isOn ? "border-primary bg-primary text-white" : "border-current opacity-40"
              )}
            >
              {isOn && <Check className="h-3 w-3" />}
            </span>
            <span>{extra.name}</span>
            <span className="opacity-70">
              +{formatCurrency(extra.price)}
              {extra.type === "perPax" ? ` ${t("quote.perPax")}` : ""}
            </span>
          </button>
        );
      })}
    </div>
  );
}
